var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uikit-form" }, [
    _c("div", { staticClass: "layout__subtitle" }, [_vm._v("Кнопки")]),
    _c("div", { staticClass: "uikit-form__buttons" }, [
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button", {
            attrs: {
              responsive: "",
              label: "Управление фильтрами",
              icon: "filter",
            },
          }),
          _c("c-button", {
            attrs: {
              responsive: "",
              label: "Новый расчет",
              icon: {
                icon: "plus",
                color: "white",
              },
              color: "blue",
            },
          }),
          _c("c-button", {
            attrs: { responsive: "", icon: "cog", label: "Настроить столбцы" },
          }),
          _c("c-button", {
            attrs: {
              responsive: "",
              label: "Новый сорудник",
              icon: {
                icon: "plus",
                color: "blue",
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button-2", {
            attrs: {
              size: "small",
              responsive: true,
              icon: "back",
              type: "with-icon",
              label: "К списку сотрудников",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button", {
            attrs: {
              icon: {
                icon: "excel",
                color: "green",
              },
              label: "Выгрузить в Excel",
              responsive: "",
            },
          }),
          _c("c-button", {
            attrs: {
              icon: {
                icon: "google",
                color: "green",
              },
              label: "Выгрузить в Google таблицы",
              responsive: "",
            },
          }),
          _c("c-button", {
            attrs: {
              icon: {
                icon: "print",
              },
              label: "Распечатать расчетный лист",
              responsive: "",
            },
          }),
          _c("c-button", {
            attrs: {
              responsive: "",
              label: "Сбросить фильтры столбцов",
              icon: { color: "pink", icon: "filter-drop" },
              type: "with-icon",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "uikit-form__row" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("c-button", {
              attrs: {
                icon: {
                  icon: "bookmark",
                  activeColor: "white",
                },
                tooltip: {
                  text: "Добавить в закладки",
                  activeText: "Убрать из закладок",
                },
                "active-color": "blue",
                active: _vm.buttons.bookmark,
              },
              on: {
                click: function ($event) {
                  _vm.buttons.bookmark = !_vm.buttons.bookmark
                },
              },
            }),
            _c("c-button-2", { attrs: { size: "small", icon: "comment" } }),
            _c("c-button-2", {
              attrs: {
                size: "small",
                icon: "edit",
                tooltip: {
                  text: "Настройки сотрудника",
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button", {
            staticClass: "m-table-settings__actions-item",
            attrs: { size: "large", label: "Сбросить" },
          }),
          _c("c-button", {
            staticClass: "m-table-settings__actions-item",
            attrs: { label: "Применить", color: "blue", size: "large" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button-2", {
            attrs: {
              size: "small",
              responsive: true,
              icon: "back",
              type: "with-icon",
              label: "К списку сотрудников",
              pending: true,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "uikit-form__row" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("c-button", {
              attrs: {
                icon: "info",
                tooltip: "Какая-то информация",
                size: "small",
                "no-border": "",
              },
            }),
            _c("c-button-2", { attrs: { size: "iconic", icon: "edit" } }),
            _c("c-button-2", {
              attrs: {
                size: "iconic",
                icon: { icon: "trash", color: "secondary" },
              },
            }),
            _c("c-button-2", {
              attrs: { size: "iconic", icon: "arrows-constructor" },
            }),
            _c("c-button", {
              attrs: {
                icon: {
                  icon: "filter-column",
                  activeColor: "blue",
                },
                tooltip: {
                  text: "Применить фильтр",
                  activeText: "Изменить фильтр",
                },
                "no-border": "",
                size: "small",
                active: _vm.buttons.filter,
              },
              on: {
                click: function ($event) {
                  _vm.buttons.filter = !_vm.buttons.filter
                },
              },
            }),
            _c("c-button-2", {
              attrs: {
                icon: "chart",
                active: !_vm.buttons.chart,
                responsive: true,
                label: _vm.buttons.chart
                  ? "Скрыть графики"
                  : "Показать графики",
                size: "small",
              },
              on: {
                click: function ($event) {
                  _vm.buttons.chart = !_vm.buttons.chart
                },
              },
            }),
            _c("c-button-2", {
              attrs: {
                size: "small",
                responsive: true,
                icon: "download",
                type: "with-icon",
                label: "Скачать одним архивом",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button-dropdown", {
            attrs: {
              icon: "arrow",
              "dropdown-with-icon": true,
              "dropdown-icon": "plus",
              "dropdown-icon-color": "blue",
              type: "dropdown",
              label: "Добавить",
              dropdown: {
                position: "left",
                items: [{ label: "Группу" }, { label: "Категорию" }],
              },
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "layout__hr" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }